export class CashRegisterPaymentCancelVendorRequest {
    vendorType?: string;
    uniqCode?: string;
    requestData?: string;
    responseData?: string;
    notes?: string;
}